export default __webpack_public_path__ + "static/media/rcp.08194985.png";